import React from 'react';
import { number, string } from 'prop-types';

const IconArrowDown = ({ height = 13, width = 14, fill = '#ffffff' }) => {
  return (
    <svg data-test="iconarrowdown" width={width} height={height} viewBox="0 0 14 13" fill="none">
      <path
        d="M6.61324 12.3501L0.0900974 0.922628L13.1364 0.922628L6.61324 12.3501Z"
        fill={fill}
      />
    </svg>
  );
};

IconArrowDown.propTypes = {
  height: number,
  width: number,
  fill: string,
};

export default IconArrowDown;
